import React from "react";
let SurveyNotEligible = () => {
  return (
    <div>
      <div className="container-fluid custom-container-fluid-background-survey">
        <div className="container">
          <div className="row not-eligible-div-header">
            <div className="col-md-12">
              <center>
                <img
                  src={require("../../Assets/Images/fpmcf_logo.png")}
                  alt="image not available"
                  height={35}
                ></img>
              </center>
            </div>
          </div>

          <div className="row not-eligible-div-header">
            <div className="col-md-12">
              <div className="not-eligible-div">
                <div className="not-eligible-text">
                  <p className="">Error-404</p>

                  <p>Invalid link. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyNotEligible;
